import { createFileRoute } from '@tanstack/react-router';

import Cases from '~/app/praetors/cases/Cases';

export const Route = createFileRoute('/_app/home/praetors/$praetorId/cases/v2/')({
	beforeLoad: () => ({
		getTitle: undefined
	}),
	component: Cases
});
